import { addYears, isAfter, subDays } from 'date-fns';
import { IntlShape } from 'react-intl';

export const calculateAgeStatus = (
  dateOfBirth: string,
  intl: IntlShape,
) => {
  const eighteenthBirthday = addYears(new Date(dateOfBirth), 18);
  const oneMonthBeforeBirthday = subDays(eighteenthBirthday, 30);
  const isDeactivatedSoon = isAfter(new Date(), oneMonthBeforeBirthday);
  const dateOfDeactivation = eighteenthBirthday.toLocaleDateString(intl.locale, {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
  });

  return {
    isDeactivatedSoon,
    dateOfDeactivation,
  };
};
